import React, { useState } from 'react';
import NewPasswordForm from '../components/NewPasswordForm';
import { UseAuth } from '../hooks/useAuth';



const NewPassword = () => {

  const {user} = UseAuth();
  
  const [accessGranted, setAccessGranted] = useState(false);
  const handleSubmit = (passwords) => {
    if (passwords.newPassword === 'Nueva Contraseña' && passwords.confirmPassword === 'Confirmar Contraseña') {
      setAccessGranted(true);
    } else {
      alert('Acceso incorrecto. Verifique su contraseña sea la misma.');
    }
  };

  return (
  
      <div className="container">
       <div className='top-bar2'>
              <div className="top-bar">
  
                  <div className="logo">
                     
                          <button className="logo-button">
                              <img src="/img/logo.png" alt="Logo de la empresa" style={{ width: '50px', marginLeft: '20px' }} />
                          </button>
                 
                  </div>
              </div>
              </div>
   

      <h1>Cambio de Contraseña</h1>
      <NewPasswordForm onSubmit={handleSubmit} />
      <footer style={{ textAlign: 'center' }}>
        Copyright © Gobierno del Estado de Durango 2024
      </footer>
    </div>
  );
};

export default NewPassword;
